var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ol',{staticClass:"wrapper"},[_c('li',{staticClass:"h6"},[_vm._v("Step")]),_vm._v(" "),_vm._l((_vm.total),function(n){return _c('li',{key:n,staticClass:"step",class:{ 'step--active': n == _vm.current },on:{"click":function($event){return _vm.$emit('changeStep', n)}}},[_vm._v("\n        "+_vm._s(n)+"\n    ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }